import React from "react";

export default function Formazione() {
  return (
    <>
      <section id="formazione" className="features moduli">
        <div className="container">
          <div className="section-title">
            <h2>Formazione</h2>
            <p>Formazione in presenza</p>
          </div>

          <div className="row content">
            <div className="col-md-7">
              <h3 className="mb-3">
                Novità!
                <br />
              </h3>
              "IO Logopedista - <strong>Formazione</strong> per il Saper Essere"
              è realizzabile <strong>in presenza</strong> per costruire insieme
              migliori competenze comunicativo-relazionali al servizio degli
              utenti e a tutela e soddisfazione dei professionisti.
              <section id="pricing" className="pricing pt-4 pb-4">
                <div className="row content">
                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Dove?</h3>
                      <div>
                        <strong>Nel tuo studio professionale</strong>
                        <br />
                        con i colleghi che desideri coinvolgere!
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                   
                                  </div> */}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4 mt-md-0">
                    <div className="box featured">
                      <h3>Come?</h3>
                      <div>
                        Scrivi a:
                        <br />
                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>
                          <strong>{process.env.REACT_APP_EMAIL}</strong>
                        </a>
                      </div>
                      {/* <div className="btn-wrap">
                                      <a className="cta-btn" href="https://shorturl.at/cAEHJ" target="_blank" rel="noreferrer">Programma Roma aprile 2024</a>                           
                                  </div> */}
                    </div>
                  </div>
                </div>
              </section>
              <p className="italianno-regular mb-4 text-center">
                Per rendere migliore la tua quotidianità professionale{" "}
                <strong>investi su di Te</strong>:<br />
                sul benessere, sulla comunicazione e sulla relazione.
              </p>
              <h3 className="mb-3">
                Elenco corsi
                <br />
              </h3>
              <div className="col-lg-12 col-md-12">
                <div className="details mt-3">
                  <div className="container">
                    <div className="row content">
                      <div className="col-12"></div>
                      <strong>In partenza</strong>
                      <ul style={{ textAlign: "left" }}>
                        <li>Bologna, 13 e 14 febbraio 2027 c/o Studio logopedico Milò</li>
                        <li>Barletta, 10 e 11 ottobre 2026 c/o Studio Agape</li>
                        <li>Roma, 26 e 27 settembre 2026 c/o Centro Multiprofessionale BLABLA.Lab</li>                       
                      </ul>

                      <strong>Corsi già svolti</strong>
                      <ul style={{ textAlign: "left" }}>
                        <li>Bologna 14 e 15 marzo 2026 - Studio
                            Multidisciplinare Giamì -{" "}
                            <em>in collaborazione con SMOF Italia</em>                        
                        </li>
                        <li className="exprired">
                          Portoscuso 21 e 22 giugno 2025 - Studio Gardenia
                        </li>
                        <li className="exprired">
                          Roma 12 e 13 aprile 2024 - CMR Specialisti dell'età
                          evolutiva
                        </li>
                      </ul>
                      {/* <a
                  className="cta-btn"
                  href="https://www.iologopedista.it/assets/share/IO-Logopedista_Formazione-CMR-Roma.pdf"
                  target="_blank"
                  rel="noreferrer"
                > 
                  Roma 12 e 13 aprile 2024 - CMR specialisti dell'età evolutiva
                </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5">
              <img
                src="assets/img/site/formazione-1.jpg"
                className="img-fluid mb-2"
                alt=""
              />
              <img
                src="assets/img/site/formazione-2.jpg"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
